import { Injectable } from '@angular/core';
import { PipelineDefinition } from '../../main/models/processing-pipeline';

const STORAGE_KEY = 'jit-pipeline-presets';

/**
 * Persists and loads pipeline presets from localStorage.
 */
@Injectable({ providedIn: 'root' })
export class PipelineStoreService {
  /** Get all saved pipeline presets. */
  getAll(): PipelineDefinition[] {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    try {
      return JSON.parse(raw);
    } catch {
      return [];
    }
  }

  /** Get a single preset by ID. */
  getById(id: string): PipelineDefinition | undefined {
    return this.getAll().find((p) => p.id === id);
  }

  /** Save a pipeline preset (creates or updates). */
  save(pipeline: PipelineDefinition): void {
    const all = this.getAll();
    const idx = all.findIndex((p) => p.id === pipeline.id);
    pipeline.updatedAt = new Date().toISOString();
    if (idx >= 0) {
      all[idx] = pipeline;
    } else {
      pipeline.createdAt = pipeline.createdAt || new Date().toISOString();
      all.push(pipeline);
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  }

  /** Delete a pipeline preset by ID. */
  delete(id: string): void {
    const all = this.getAll().filter((p) => p.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  }

  /** Generate a unique ID for a new pipeline. */
  generateId(): string {
    return `pipeline-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }
}
